// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Halo Universe - Star Systems Configuration
 * 
 * UNSC space with Covenant worlds and Forerunner installations
 */

export const starSystems = [
  {
    id: 1800,
    name: 'UNSC Infinity',
    type: 'station',
    distance: 0,
    coordinates: { x: 45, y: 50, z: 0 },
    threat: 'SAFE',
    resources: 'UNSC HUB',
    services: ['refuel', 'repairs', 'trade', 'weapons', 'upgrades', 'modules'],
    tradeType: 'station_advanced',
    primaryColor: '#0066cc',
    secondaryColor: '#004499',
    hasRings: false,
    description: 'UNSC\'s largest warship. Mobile command center for Spartan operations.'
  },
  {
    id: 1801,
    name: 'Reach',
    type: 'planet',
    distance: 12,
    coordinates: { x: 58, y: 55, z: 3 },
    threat: 'VERY HIGH',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'weapons'],
    tradeType: 'industrial',
    primaryColor: '#cc6600',
    secondaryColor: '#994400',
    hasRings: false,
    description: 'Former UNSC stronghold. Glassed by Covenant. "Remember Reach."'
  },
  {
    id: 1802,
    name: 'Earth',
    type: 'planet',
    distance: 18,
    coordinates: { x: 35, y: 58, z: -4 },
    threat: 'MODERATE',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'weapons', 'upgrades'],
    tradeType: 'agricultural',
    primaryColor: '#0088ff',
    secondaryColor: '#00cc66',
    hasRings: false,
    description: 'Humanity\'s homeworld. Defended against Covenant invasion. UNSC headquarters.'
  },
  {
    id: 1803,
    name: 'Installation 04 (Alpha Halo)',
    type: 'station',
    distance: 25,
    coordinates: { x: 62, y: 42, z: 8 },
    threat: 'EXTREME',
    resources: 'FORERUNNER',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#00ff88',
    secondaryColor: '#00cc66',
    hasRings: true,
    description: 'Forerunner ringworld. Destroyed to prevent Flood outbreak. Ancient secrets remain.'
  },
  {
    id: 1804,
    name: 'Installation 05 (Delta Halo)',
    type: 'station',
    distance: 28,
    coordinates: { x: 28, y: 45, z: -6 },
    threat: 'EXTREME',
    resources: 'FORERUNNER',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#00ff88',
    secondaryColor: '#00cc66',
    hasRings: true,
    description: 'Second Halo ring. Site of the Great Schism. Gravemind\'s prison.'
  },
  {
    id: 1805,
    name: 'High Charity',
    type: 'station',
    distance: 30,
    coordinates: { x: 68, y: 58, z: -10 },
    threat: 'EXTREME',
    resources: 'COVENANT',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#9933ff',
    secondaryColor: '#6600cc',
    hasRings: false,
    description: 'Former Covenant holy city. Infested by Flood. Crashed on the Ark.'
  },
  {
    id: 1806,
    name: 'Sanghelios',
    type: 'planet',
    distance: 22,
    coordinates: { x: 52, y: 65, z: 5 },
    threat: 'MODERATE',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'weapons'],
    tradeType: 'industrial',
    primaryColor: '#cc00cc',
    secondaryColor: '#990099',
    hasRings: false,
    description: 'Elite homeworld. Honor-bound warrior culture. Arbiter\'s domain.'
  },
  {
    id: 1807,
    name: 'Balaho',
    type: 'planet',
    distance: 20,
    coordinates: { x: 38, y: 38, z: 3 },
    threat: 'LOW',
    resources: 'LOW',
    services: ['refuel', 'exploration', 'repairs'],
    tradeType: 'remote',
    primaryColor: '#00ccff',
    secondaryColor: '#0099cc',
    hasRings: false,
    description: 'Grunt homeworld. Methane atmosphere. Unggoy breeding grounds.'
  },
  {
    id: 1808,
    name: 'Doisac',
    type: 'planet',
    distance: 26,
    coordinates: { x: 58, y: 35, z: -8 },
    threat: 'HIGH',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'weapons'],
    tradeType: 'industrial',
    primaryColor: '#ff4400',
    secondaryColor: '#cc3300',
    hasRings: false,
    description: 'Brute homeworld. Brutal warrior culture. Destroyed by Cortana.'
  },
  {
    id: 1809,
    name: 'Requiem',
    type: 'planet',
    distance: 35,
    coordinates: { x: 70, y: 50, z: 12 },
    threat: 'EXTREME',
    resources: 'FORERUNNER',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#ff8800',
    secondaryColor: '#cc6600',
    hasRings: false,
    description: 'Forerunner shield world. Didact\'s prison. Advanced Promethean forces.'
  },
  {
    id: 1810,
    name: 'The Ark',
    type: 'station',
    distance: 40,
    coordinates: { x: 25, y: 68, z: -15 },
    threat: 'EXTREME',
    resources: 'FORERUNNER',
    services: ['refuel', 'exploration'],
    tradeType: 'remote',
    primaryColor: '#ffaa00',
    secondaryColor: '#ff8800',
    hasRings: true,
    description: 'Installation 00. Halo forge. Outside the galaxy. Final battle site.'
  },
  {
    id: 1811,
    name: 'Onyx (Shield World)',
    type: 'planet',
    distance: 32,
    coordinates: { x: 48, y: 70, z: 8 },
    threat: 'VERY HIGH',
    resources: 'FORERUNNER',
    services: ['refuel', 'exploration', 'upgrades'],
    tradeType: 'remote',
    primaryColor: '#666666',
    secondaryColor: '#444444',
    hasRings: false,
    description: 'Forerunner shield world. Spartan training ground. Sentinels everywhere.'
  }
];

export const starPositions = starSystems.reduce((acc, system) => {
  acc[system.id] = system.coordinates;
  return acc;
}, {});
